import { render, staticRenderFns } from "./MembershipService.vue?vue&type=template&id=655c30d6"
import script from "./MembershipService.vue?vue&type=script&lang=js"
export * from "./MembershipService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports